angular.module("Main").controller("Step3Controller", ["$rootScope", "$scope", "$state", "$stateParams",
    "$localStorage", "$window", "$uibModal", "$translate", "BookingService",
    "PaymentService", "SessionService", "DialogService",
    function ($rootScope, $scope, $state, $stateParams, $localStorage, $window, $uibModal, $translate, BookingService,
              PaymentService, SessionService, DialogService) {
        var vm = this;

        vm.imageUrl = BookingService.getAppointmentTypeImagePath();
        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.showPayments = false;
        vm.choosenPaymentMethod = null;
        vm.reservationError = false;
        vm.RessourceSelected = false;
        vm.selectedRessource = null;
        vm.ressourcesToSelect = [];
        vm.bookAsTrainerFailed = false;
        vm.ageLimit = false;
        vm.messageClub = null;

        if (screen.width < 600) {
            vm.isMobilePhone = true;
            vm.weekView = true
        } else {
            vm.isMobilePhone = false;
            vm.weekView = true;
        }


        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkUser();
            init();
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            $localStorage.user = {};
            unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
        });

        if (!SessionService.getSessionId()) {
            unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
        } else
            start();

        function start() {
            vm.cookies = SessionService.checkSession();
            checkUser();
            init();
        }

        loadConfigs();
        getKursbuchungLayouKonfiguration();
        checkIfSixPaymentConfig();
        checkTerminartPayments();


        function checkRessources() {
            vm.cookies = SessionService.checkSession();
            //ToDo Nur Mitarbeiter Ressourcen
            let ids = vm.cookies.meetingDate.RessourcesAuswahl[0].length > 0 ? _.intersection(vm.cookies.meetingDate.RessourcesAuswahl[0], vm.cookies.meetingDate.RessourceIds[0]) : vm.cookies.meetingDate.RessourceIds[0]
            BookingService.checkRessourcesData(ids).then(function (data) {
                vm.ressourcesToSelect = data;
            });
            BookingService.getResourcesForAppointment(vm.cookies.meetingData.Nr).then(function (resources) {
                vm.hatRechteAuswahl = resources.length > 0 || vm.isTrainer;
            });
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function checkIfSixPaymentConfig() {
            BookingService.checkSixConfig().then(function (data) {
                vm.isSixPayment = data.paymentValid;
            })
        }

        function checkTerminartPayments() {
            BookingService.checkPayments(vm.meetingData.Nr).then(function (data) {
                vm.terminartPayments = data;
            })
        }

        $('#register-focus').autofocus;

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });
            BookingService.checkBarzahlungEndpoint().then(function () {
                vm.checkBarZahlungEndpointFailed = false;
            }).catch(function (error) {
                vm.checkBarZahlungEndpointFailed = true;

            });
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('angebot', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), dt: SessionService.getAuthDtData()})
                }
            }
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
            vm.isTrainer = $stateParams.id === 'tt';
        }

        vm.booking = {};

        function checkImage(nr) {
            BookingService.getTerminImage(nr).then(function (image) {
                vm.Bild = image;
            })
        }


        function init() {
            vm.Bild = null;
            if (_.isNil(vm.cookies.meetingData) || _.isNil(vm.cookies.meetingDate)) {
                unregisterEventHandler();
                $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
            } else {
                checkRessources();
                checkImage(vm.cookies.meetingData.Nr);
                if (vm.isLoggedIn) {
                    if(vm.cookies.meetingData.BuchungslimitMitgliedZulassen) {
                        BookingService.checkAppointmentMemberLimit(vm.currentUser.memberNr, vm.cookies.meetingDate.Day, vm.cookies.meetingDate.End).then(function (limit) {
                            if (limit.Count > 0){
                                vm.limitMember = limit;
                            }
                        }).catch(function () {
                        });
                    }
                    if(vm.cookies.meetingData.Altersbeschraenkung > 0) {
                        BookingService.checkAltersbeschraenkung(vm.currentUser.memberNr, vm.cookies.meetingDate.TerminartNr, vm.cookies.meetingDate.Day).then(function (age) {
                            if (age.Limit){
                                vm.ageLimit = true;
                            }
                        }).catch(function (error) {
                            console.log(error)
                        });
                    }
                    BookingService.checkAppointmentGroupLimit(vm.cookies.meetingData.Nr, vm.currentUser.memberNr, vm.cookies.meetingDate.Day).then(function (limits) {
                        if (limits && ((limits.day && limits.day.reached) || (limits.week && limits.week.reached) ||
                                (limits.month && limits.month.reached) || (limits.year && limits.year.reached))) {
                            vm.limits = limits;
                        }
                    }).catch(function () {
                    });
                    if (vm.cookies.meetingData.Bezahlung === 3) {
                        PaymentService.getArticlePrice(vm.currentUser.uid, vm.cookies.meetingDate.TerminartNr, vm.cookies.meetingDate.Day)
                            .then(function (priceData) {
                                if (!_.isEmpty(priceData))
                                    vm.cookies.meetingData.PreisZahl = priceData.Price;
                                vm.meetingData.PreisZahl = priceData.Price;
                            }).catch(function () {
                        }).then(function () {
                            BookingService.checkAppointmentGroupLimit(vm.cookies.meetingData.Nr, vm.currentUser.memberNr, vm.cookies.meetingDate.Day).then(function (limits) {
                                if (limits && ((limits.day && limits.day.reached) || (limits.week && limits.week.reached) ||
                                        (limits.month && limits.month.reached) || (limits.year && limits.year.reached))) {
                                    vm.limits = limits;
                                }
                            }).catch(function () {
                            })
                        })
                    }
                }
                vm.meetingData = vm.cookies.meetingData;
                vm.meetingDate = vm.cookies.meetingDate;
                vm.selectedPayment = "0";
                if (vm.meetingData.Bezahlung < 1 || vm.meetingData.Bezahlung > 3)
                    vm.meetingData.Bezahlung = 1;

                BookingService.loadAppointmentType(vm.meetingData.Nr).then(function (s) {
                    vm.backColor = s[0].Farbe;
                });
                // BookingService.getResourceNames(vm.meetingDate).then(function (names) {
                //     vm.MitarbeiterRessource = _.join(_.map(_.sortBy(_.filter(names, {Mitarbeiter: 1}), 'Bezeichnung'), "Bezeichnung"), " ,");
                //     vm.NichtMitarbeiterRessource = _.sortBy(_.filter(names, {Mitarbeiter: 0}), 'Bezeichnung');
                //     let ressourcesAll = _.concat(vm.MitarbeiterRessource, vm.NichtMitarbeiterRessource);
                //     vm.resourceNames = _.join(_.map(ressourcesAll, "Bezeichnung"), " ,");
                // });
                BookingService.loadConfigurationStammdaten().then(function (texts) {
                    vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
                    if (texts.TextObligatory) {
                        vm.endTextFree = "T_Jetzt_verpflichtend_buchen";
                        vm.endText = "T_Jetzt_kostenpflichtig_buchen";
                    } else {
                        vm.endTextFree = "T_Jetzt_Buchen";
                        vm.endText = "T_Jetzt_Bezahlen";
                    }
                });
            }
        }

        vm.bookAsTrainer = function () {
            if (!vm.spinner) {
                let end = vm.meetingDate.End;
                let timeEnd = moment(vm.meetingDate.End).format("HH:mm");
                if(timeEnd === '00:00') {
                    let newEnd = moment(end).subtract('minutes', 1).format();
                    vm.meetingDate.End = new Date(newEnd);
                }
                var tempBooking = {
                    PersonNr: null,
                    TerminartNr: vm.meetingDate.TerminartNr,
                    RessourcenIds: _.flattenDeep(vm.meetingDate.RessourceIds),
                    Start: vm.meetingDate.Day,
                    Ende: vm.meetingDate.End,
                    Language: $translate.use(),
                    ResourcesData: vm.meetingDate.ResourcesData,
                    Zahlart: null,
                    SelectedRess: vm.selectedRessource ? [vm.selectedRessource.Nr] : []
                };
                vm.spinner = true;
                BookingService.createTrainerBooking(tempBooking).then(function (url) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $window.top.location.href = url.redirectUrl;
                }).catch(function (error) {
                    vm.spinner = false;
                    if (error.status === 487) {
                        vm.resNotAvailable = true;
                    }
                    vm.bookAsTrainerFailed = true;
                })
            }
        };

        vm.bookAsLoggedIn = function () {
            if (vm.meetingData.PreisZahl > 0 && (vm.selectedPayment === "1" || vm.meetingData.Bezahlung === 2)) {
                bookSix();
            } else {
                bookWithoutPayment();
            }
        };

        vm.bookAsLoggedInVorOrt = function (method) {
            init();
            bookWithoutPayment(method);
        };

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.privacytermsText = data.PrivacyPolicy;
            });
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.loginModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        vm.registerModal = function () {
            SessionService.clear('globals');
            DialogService.openRegisterDialog(vm.meetingData.PreisZahl).then(function(data){
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            }).catch(function () {

            })
        };

        function bookSix() {
            if (!vm.spinner) {
                let end = vm.meetingDate.End;
                let timeEnd = moment(vm.meetingDate.End).format("HH:mm");
                if(timeEnd === '00:00') {
                    let newEnd = moment(end).subtract('minutes', 1).format();
                    vm.meetingDate.End = new Date(newEnd);
                }
                var tempBooking = {
                    PersonNr: vm.currentUser.memberNr,
                    TerminartNr: vm.meetingDate.TerminartNr,
                    RessourcenIds: vm.meetingDate.RessourceIds,
                    Start: vm.meetingDate.Day,
                    Ende: vm.meetingDate.End,
                    Language: $translate.use(),
                    ResourcesData: vm.meetingDate.ResourcesData,
                    LinkId: $stateParams.id,
                    Leistungsarten: vm.meetingData.Leistungsarten,
                    MitgliedsOption: vm.meetingData.MitgliedsOption
                };
                vm.spinner = true;
                PaymentService.startPayment(tempBooking).then(function (url) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $window.location.href = url.redirectUrl;
                }).catch(function (reason) {
                    vm.spinner = false;
                    if (reason.status === 487) {
                        vm.bookingLost = true;
                        vm.cashBack = false;
                        vm.resNotAvailable = true;
                    }
                    if (reason.status === 410) {
                        vm.reservationError = true;
                    }
                    if (reason.status === 400) {
                        unregisterEventHandler();
                        if (reason.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                            $state.go("nutzungsrechte_member", {
                                cid: SessionService.getAuthData(),
                                id: SessionService.getAuthIdData(),
                                isKurs: false,
                                isTermin: true,
                                text: vm.meetingData.NutzungsrechteText
                            });
                        }
                        if (reason.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                            $state.go("nutzungsrechte_member", {
                                cid: SessionService.getAuthData(),
                                id: SessionService.getAuthIdData(),
                                isKurs: false,
                                isTermin: true,
                                text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                            });
                        }
                    } else {
                        unregisterEventHandler();
                        $state.go("payment_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                    }
                });
            }
        }

        function bookWithoutPayment(method) {
            if (!vm.spinner) {
                let end = vm.meetingDate.End;
                let timeEnd = moment(vm.meetingDate.End).format("HH:mm");
                if(timeEnd === '00:00') {
                    let newEnd = moment(end).subtract('minutes', 1).format();
                    vm.meetingDate.End = new Date(newEnd);
                }
                var tempBooking = {
                    PersonNr: vm.currentUser.uid,
                    TerminartNr: vm.meetingDate.TerminartNr,
                    RessourcenIds: _.flattenDeep(vm.meetingDate.RessourceIds),
                    Start: vm.meetingDate.Day,
                    Ende: vm.meetingDate.End,
                    Language: $translate.use(),
                    ResourcesData: vm.meetingDate.ResourcesData,
                    Zahlart: _.upperCase(method),
                    Leistungsarten: vm.meetingData.Leistungsarten,
                    MitgliedsOption: vm.meetingData.MitgliedsOption,
                    SelectedRess: vm.selectedRessource ? [vm.selectedRessource.Nr] : [],
                    Text: vm.messageClub,
                    RessourcenartenNrs: _.map(vm.meetingDate.ResourcesData, 'resTypeNr')
                };
                vm.spinner = true;
                BookingService.createBooking(tempBooking).then(function (orderId) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $state.go('booking_success', {cid: SessionService.getAuthData(), locale: true, oid: orderId, id: SessionService.getAuthIdData()});
                }).catch(function (error) {
                        vm.spinner = false;
                        if (error.status === 400) {
                            unregisterEventHandler();
                            if (error.data.message === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                                $state.go("nutzungsrechte_member", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    text: vm.meetingData.NutzungsrechteText
                                });
                            }
                            if (error.data.message === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                                $state.go("nutzungsrechte_member", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                                });
                            }
                            if (error.data.message === "LT_MEMBER_ALREADY") {
                                $state.go("payment_member_already", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    message: error.data.message,
                                    start: error.data.start,
                                    ende: error.data.ende,
                                    name: error.data.name
                                });
                            }
                            if (error.data.message === "RESOURCE_NOT_AVAILABLE" || error.data.message === "T_Maximal_count_of_Members_reached" || error.data.message === 'LT_CANT_BOOK_TOO_LONG') {
                                $state.go("booking_slot_too_long", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    message: "LT_BOOKING_TOO_LONG"
                                });
                            }
                        } else {
                            vm.reserveError = true;
                            unregisterEventHandler();
                            $state.go("booking_termin_error", {
                                cid: SessionService.getAuthData(),
                                message: error,
                                id: SessionService.getAuthIdData(),
                                oid: $stateParams.oid
                            });
                        }
                    }
                )
            }
        }

        vm.goToAngebot = function () {
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        function bookPayPal() {
            if (!vm.spinner) {
                let end = vm.meetingDate.End;
                let timeEnd = moment(vm.meetingDate.End).format("HH:mm");
                if(timeEnd === '00:00') {
                    let newEnd = moment(end).subtract('minutes', 1).format();
                    vm.meetingDate.End = new Date(newEnd);
                }
                var tempBooking = {
                    PersonNr: vm.currentUser.uid,
                    TerminartNr: vm.meetingDate.TerminartNr,
                    RessourcenIds: vm.meetingDate.RessourceIds,
                    Start: vm.meetingDate.Day,
                    Ende: vm.meetingDate.End,
                    Language: $translate.use(),
                    ResourcesData: vm.meetingDate.ResourcesData,
                    LinkId: $stateParams.id,
                    Leistungsarten: vm.meetingData.Leistungsarten,
                    MitgliedsOption: vm.meetingData.MitgliedsOption,
                    SelectedRess: vm.selectedRessource ? [vm.selectedRessource.Nr] : [],
                    Text: vm.messageClub
                };
                vm.spinner = true;
                PaymentService.startPaymentPayPal(tempBooking).then(function (url) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $window.location.href = url.redirectUrl;
                }).catch(function (reason) {
                    vm.spinner = false;
                    if (reason.status === 500) {
                        unregisterEventHandler();
                        $state.go("payment_pp_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: $stateParams.oid});
                    } else {
                        if (reason.status === 487) {
                            vm.bookingLost = true;
                            vm.cashBack = false;
                            vm.resNotAvailable = true;
                        }
                        if (reason.status === 488) {
                            vm.reservationError = true;
                        }
                        if (reason.status === 400) {
                            unregisterEventHandler();
                            if (reason.data === "LT_CANT_BOOK_NUTZUNGSRECHTE") {
                                $state.go("nutzungsrechte_member", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    text: vm.meetingData.NutzungsrechteText
                                });
                            }
                            if (reason.data === "LT_CANT_BOOK_MITGLIEDSOPTION") {
                                $state.go("nutzungsrechte_member", {
                                    cid: SessionService.getAuthData(),
                                    id: SessionService.getAuthIdData(),
                                    isKurs: false,
                                    isTermin: true,
                                    text: "LT_CANT_BOOK_MITGLIEDSOPTION"
                                });
                            }
                        }
                        else if (reason.status === 489) {
                            unregisterEventHandler();
                            $state.go("payment_member_already", {
                                cid: SessionService.getAuthData(),
                                id: SessionService.getAuthIdData(),
                                isKurs: false,
                                isTermin: true,
                            });
                        } else if (reason.status !== 487 && reason.status !== 488 && reason.status !== 489) {
                            $state.go("payment_pp_fail", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: reason.data.oid});
                        }

                    }
                })
            }
        }

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.payNow = function (method) {
            if (method === 'pp') {
                bookPayPal();
            }
            if (method === 'six') {
                bookSix()
            }
            if (method === 'ls' || method==='bar') {
                bookWithoutPayment(method);
            }
        };

        vm.selectRessource = function (ress) {
            vm.selectedRessource = ress;
            vm.RessourceSelected = true;
        }
    }])
;